import React, {useContext} from 'react'
import { EditedContext } from '../../../../partials/Context'

function SocialMedia() {
    const edited = useContext(EditedContext);
    const {changeBtn, edited_item, input_value, setInputValue, lawyer_data, setEditedItem} = edited || '';
    
    const {social_media} = lawyer_data || '';
    const {blog_url, facebook_url, twitter_url} = social_media || '';

    const {social_media: input_social_media} = input_value || ''
    const {blog_url: input_blog, facebook_url: input_facebook, twitter_url: input_twitter} = input_social_media || '' 

    const social_media_arr = [
        {
            title: 'blog',
            variable_name: 'blog_url',
            url: blog_url,
            input: input_blog
        },
        {
            
            title: 'facebook',
            variable_name: 'facebook_url',
            url: facebook_url,
            input: input_facebook
        },
        {
            title: 'twitter',
            variable_name: 'twitter_url',
            url: twitter_url,
            input: input_twitter
        },
    ]

    let list = []

    social_media_arr.forEach((item, index) => {
        const {title, variable_name, url, input} = item || '';
        list.push(
            <div className="row" key={index}>
                <span className="form-title">{title}</span>
                {edited_item === title ? 
                    <input type="url" className="form-input" value={input} onChange={(e)=>setInputValue( {social_media: {[variable_name]: e.target.value}})}/>
                    :
                    <span id={title} className="social-media-value" onClick={() => {
                            setInputValue({social_media: {[variable_name]: [url]}});
                            setEditedItem(title)
                        }}>{url ? url : '-'}</span>
                }
                {changeBtn(title)}
            </div>
        )
    })

  return (
    <div id="social-media" className="top-buffer">
        <h1 className="title"> Social Media</h1>
        <div id="social-media-content">
            {list}
        </div>
    </div>
  )
}

export default SocialMedia